<template>
  <div class="d-flex flex-row justify-center">
    <template v-if="eventLimit">
      <div v-if="eventLimit.maxNumberOfAthletes" class="d-flex">
        <small class="align-self-center" :class="chipBoxColor">{{
          $t(
            "events:schedule.SetDailyLimit.uniqueAthletes.text",
            "unique athletes:"
          )
        }}</small>
        <AppShowChipBoxes :items="athleteStats" :color="chipBoxColor" />
      </div>

      <div class="d-flex">
        <template
          v-if="eventLimit.maxNumberOfEntries && eventLimit.maxNumberOfAthletes"
        >
          <small class="align-self-center" :class="chipBoxColor">{{
            $t(
              "events:schedule.SetDailyLimit.uniqueEntries.text",
              "unique entries:"
            )
          }}</small>
        </template>
        <AppShowChipBoxes :items="entryStats" :color="chipBoxColor" />
      </div>
      <div v-if="eventLimit.maxNumberOfHorsesPerAthlete" class="d-flex">
        <small class="align-self-center" :class="chipBoxColor">{{
          $t(
            "events:schedule.SetDailyLimit.maxNumberOfHorsesPerAthlete.text",
            "max horses per athlete:"
          )
        }}</small>
        <AppShowChipBoxes
          :items="[
            {
              name: 'maxNumberOfHorsesPerAthlete',
              value: eventLimit.maxNumberOfHorsesPerAthlete
            }
          ]"
          :color="chipBoxColor"
        />
      </div>
      <div v-if="eventLimit.maxNumberOfEntriesPerHorse" class="d-flex">
        <small class="align-self-center" :class="chipBoxColor">{{
          $t(
            "events:schedule.SetDailyLimit.maxNumberOfEntriesPerHorse.text",
            "horse can start:"
          )
        }}</small>
        <AppShowChipBoxes
          :items="[
            {
              name: 'maxNumberOfEntriesPerHorse',
              value: eventLimit.maxNumberOfEntriesPerHorse
            }
          ]"
          :color="chipBoxColor"
        />
      </div>
    </template>
    <AppShowChipBoxes
      v-else
      :items="[{ name: 'registrationsCount', value: registrationsCount }]"
      :color="chipBoxColor"
    />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";
import AppShowChipBoxes from "@AppShows/AppShowChipBoxes.vue";
export default defineComponent({
  name: "AppShowCompetitionsStarts",
  components: {
    AppShowChipBoxes
  },
  props: {
    competitions: {
      type: Array,
      default: () => []
    },
    eventLimit: {
      type: Object,
      default: null
    },
    chipBoxColor: {
      type: String,
      default: "text-muted"
    }
  },
  computed: {
    registrationsCount() {
      return this.competitions.reduce(
        (total, c) => (total += c.registrationsCount),
        0
      );
    },
    athleteStats() {
      const { maxNumberOfAthletes, athletesRegistrationConfirmedCount } =
        this.eventLimit;

      const arr = [
        { name: "athletesConfirmed", value: athletesRegistrationConfirmedCount }
      ];

      if (maxNumberOfAthletes) {
        arr.push({
          name: "athleteMax",
          value: maxNumberOfAthletes
        });
      }
      return arr;
    },
    entryStats() {
      const { maxNumberOfEntries, entriesRegistrationConfirmedCount } =
        this.eventLimit;

      const arr = [
        { name: "entriesConfirmed", value: entriesRegistrationConfirmedCount }
      ];

      if (maxNumberOfEntries) {
        arr.push({
          name: "entriesMax",
          value: maxNumberOfEntries
        });
      }
      return arr;
    }
  },
  fragments: {
    competitionFields: gql`
      fragment _ on Competition {
        registrationsCount
      }
    `,
    eventLimitFields: gql`
      fragment _ on EventLimit {
        id

        maxNumberOfAthletes
        athletesRegistrationConfirmedCount

        maxNumberOfEntries
        entriesRegistrationConfirmedCount

        maxNumberOfHorsesPerAthlete
        maxNumberOfEntriesPerHorse
      }
    `
  }
});
</script>
